import script from "./LeagueMatchTeamTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueMatchTeamTable.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueMatchTeamTable.vue?vue&type=style&index=0&id=5747dafc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5747dafc"]])

export default __exports__